export default __webpack_public_path__ + "static/media/left.975e2b83.png";